






















import Vue from 'vue';
import { uploadPublicUrlImage } from '@/web/services/upload';
import HMUnsplashImageSelectModal from '@/web/components/common/HMUnsplashImageSelectModal.vue';
import { makeid } from '@/core/utils/utils';

export default Vue.extend({
  name: 'HMUnsplashUpload',
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isUploading: false,
      selectedImageUrl: '',
      selectedImageThumbnailUrl: '',
    };
  },
  methods: {
    selectUnsplashImage() {
      this.$modal.show(
        HMUnsplashImageSelectModal,
        {
          onSelect: this.imageSelected,
        },
        {
          classes: ['vm--inline-modal'],
        }
      );
    },
    imageSelected(selectedUnsplashImage) {
      console.log('selectedUnsplashImage=', selectedUnsplashImage);
      if (!selectedUnsplashImage) return;
      this.selectedImageUrl = selectedUnsplashImage.urls.regular;
      this.selectedImageThumbnailUrl = selectedUnsplashImage.urls.thumb;
    },
    async upload() {
      this.isUploading = true;
      let filename = makeid(32);
      try {
        filename = this.selectedImageUrl.match(/.*\/([^?]+)/)[1];
      } catch (error) {
        console.log('Failed to parse filename, using random one');
      }
      const file = await uploadPublicUrlImage(
        filename,
        this.selectedImageUrl,
        this.selectedImageThumbnailUrl
      );
      this.updateFile(file);
      this.isUploading = false;
      return file;
    },
    updateFile(file) {
      this.$emit('input', file);
    },
  },
});
